<template>
  <div class="user" v-if="patient">
    <breadcrumbs>
      <div class="breadcrumbs-actions">
        <i class="material-icons">history</i>
        <router-link :to="{ name: 'edit-user', params: { id: this.$route.params.id}}">
          <rp-sprite class="create-icon" name="create"/>
        </router-link>
        <!-- <rp-sprite @click.native="onPatientRemoveModalOpen" name="delete_outline"/> -->
      </div>
    </breadcrumbs>

    <div class="content">
      <div class="user-info">
        <div class="info-item">
          <span>Patient ID</span>
          <span>{{patient.profile.id}}</span>
        </div>
        <div class="info-item">
          <span>Email Address</span>
          <span>{{patient.email}}</span>
        </div>
        <div class="info-item">
          <span>First Name</span>
          <span>{{patient.profile.first_name}}</span>
        </div>
        <div class="info-item">
          <span>Gender</span>
          <span>{{}}</span>
          <span>{{patient.profile.gender | genderFilter}}</span>
        </div>
        <div class="info-item">
          <span>Last Name</span>
          <span>{{patient.profile.last_name}}</span>
        </div>
        <div class="info-item">
          <span>Date of birth</span>
          <span>{{patient.profile.dob}}</span>
        </div>
      </div>

      <user-delete-modal
        :user="userName"
        :show="showPatientRemoveModal"
        :onClose="onPatientRemoveModalClose"
        :onConfirm="onPatientRemoveModalConfirm"/>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import UserDeleteModal from '@/components/UserDeleteModal'
import RpSprite from 'raypro_ui/src/components/ui/Sprite'
import {getUser, deleteUser} from 'raypro_ui/src/api/users'
import page from '@/mixins/page'

export default {
  components: {
    Breadcrumbs,
    UserDeleteModal,
    RpSprite
  },

  data() {
    return {
      patient: null,
      showPatientRemoveModal: false,
      title: 'User'
    }
  },

  mixins: [page],

  filters: {
    genderFilter(gender) {
      if(gender === 'PATIENT DELETED') {
        return gender
      }
      if(gender === 'M') {
        return 'Male'
      }
      if(gender === 'F') {
        return 'Female'
      }
      if(gender === 'O') {
        return 'Prefer not to say'
      }

      return 'NOT PROVIDED'
    }
  },

  mounted() {
    const id = this.$route.params.id

    getUser({id}).then(({data}) => {
      this.patient = data
    })
  },

  computed: {
    userName() {
      return `${this.patient.profile.first_name} ${this.patient.profile.last_name}`
    }
  },

  methods: {
    onPatientRemoveModalClose() {
      this.showPatientRemoveModal = false
    },

    onPatientRemoveModalOpen() {
      this.showPatientRemoveModal = true
    },

    onPatientRemoveModalConfirm() {
      const id = this.patient.id

      deleteUser({id})
        .then(() => {
          // close modal
          this.showPatientRemoveModal = false

          // redirect to all patients page
          this.$router.push('/patients')
        })
    }
  }
}
</script>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.user
  .breadcrumbs .actions
    color: $color-side-nav

    i
      margin-left: 1.5rem
      font-size: 2.5rem
      cursor: pointer

  .content
    max-width: 100rem
    padding: 30px

    .user-info
      display: flex
      flex-wrap: wrap

      .info-item
        width: 50%
        display: flex
        font-size: 1.6rem
        margin-bottom: 5rem
        color: $color-side-nav

        span:nth-of-type(1)
          width: 15rem
          font-weight: $font-regular

        span:nth-of-type(2)
          flex-grow: 1
          font-weight: $font-medium

    .user-notes
      margin-top: 2rem

      .title
        margin-bottom: 2rem
        font-size: 1.8rem
        color: $color-side-nav

      p
        font-size: 14px
        line-height: 2rem
        margin-bottom: 1rem
        color: $color-side-nav
</style>



// WEBPACK FOOTER //
// src/components/pages/Users/User.vue